import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";

const entries = [
  {
    title: "仙剑正传系列",
    desc: "从仙灵岛到锁妖塔，重温仙剑本传的经典剧情与人物命运。",
    count: "3 部作品",
    icon: "ri-sword-line",
    to: "/category?cat=正传",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20immortal%20island%20above%20sea%20of%20clouds%20with%20ancient%20pavilions%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20tranquil%20mood%2C%20no%20text&width=800&height=560&seq=xj-cat-01&orientation=landscape",
  },
  {
    title: "周边与衍生作品",
    desc: "续作、重制与番外演绎，用另一种视角走进熟悉的仙侠世界。",
    count: "2 部作品",
    icon: "ri-book-2-line",
    to: "/category?cat=衍生",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20ancient%20scroll%20and%20brush%20on%20a%20mountain%20desk%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20scholarly%20mood%2C%20no%20text&width=800&height=560&seq=xj-cat-02&orientation=landscape",
  },
  {
    title: "相关仙侠剧",
    desc: "《陈情令》《三生三世》等同类佳作，扩展你的仙侠观影版图。",
    count: "7 部作品",
    icon: "ri-film-line",
    to: "/category?cat=相关",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20night%20sky%20with%20glowing%20swords%20and%20constellations%20over%20mountains%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20Chinese%20fantasy%20art%2C%20grand%20mood%2C%20no%20text&width=800&height=560&seq=xj-cat-03&orientation=landscape",
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="Channels"
        title="按主题进入频道"
        description="围绕仙剑正传、周边衍生与相关仙侠剧三大主题，快速定位你想看的作品。"
      />
      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.title}
            to={entry.to}
            className="group relative flex h-56 flex-col justify-end overflow-hidden rounded-lg md:h-64"
          >
            <img
              src={entry.image}
              alt={entry.title}
              title={`${entry.title} 频道入口`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/45 to-primary-950/10"></div>
            <div className="relative z-10 p-5 md:p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold text-background-50">
                {entry.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-primary-100">{entry.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-400">
                {entry.count}
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}